module.exports = __webpack_public_path__ + "static/media/LeadCX.d5932c16.jpg";